module.exports = __webpack_public_path__ + "static/pos-b805909487721d18bccef541f7c65ed2.mp4";